// Only consented production traffic is sent to analytics; no customer details are included.
export function analyticsEvent(name, params = {}) {
  try {
    if (!['vintagetreyjur.is', 'www.vintagetreyjur.is'].includes(window.location.hostname)) return false;
    if (localStorage.getItem('vt_cookie_consent') !== 'accepted') return false;
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', name, params);
    return true;
  } catch { return false; }
}

export function commerceEvent(name, items, extra = {}) {
  try {
    if (!['vintagetreyjur.is', 'www.vintagetreyjur.is'].includes(window.location.hostname)) return false;
    if (localStorage.getItem('vt_cookie_consent') !== 'accepted') return false;

    const value = items.reduce((sum, item) => sum + Number(item.price) * (item.quantity || 1), 0);
    const gaItems = items.map(item => ({
      item_id: item.product_id || item.id,
      item_name: item.name,
      item_variant: item.size,
      price: Number(item.price),
      quantity: item.quantity || 1,
    }));

    let sent = false;

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, {
        currency: 'ISK',
        value,
        items: gaItems,
        ...extra,
      });
      sent = true;
    }

    const metaEventNames = {
      view_item: 'ViewContent',
      add_to_cart: 'AddToCart',
      begin_checkout: 'InitiateCheckout',
      purchase: 'Purchase',
    };
    const metaEvent = metaEventNames[name];

    if (metaEvent && typeof window.fbq === 'function') {
      window.fbq('track', metaEvent, {
        content_ids: items.map(item => String(item.product_id || item.id)),
        content_name: items.length === 1 ? items[0].name : undefined,
        content_type: 'product',
        contents: items.map(item => ({
          id: String(item.product_id || item.id),
          quantity: item.quantity || 1,
          item_price: Number(item.price),
        })),
        currency: 'ISK',
        value: Number(extra.value ?? value),
      });
      sent = true;
    }

    return sent;
  } catch { return false; }
}

export function trackPurchase(order) {
  if (!order.id) return;
  try {
    const key = 'vt_purchase_' + order.id;
    if (localStorage.getItem(key)) return;
    const value = (order.items || []).reduce((sum, item) => sum + Number(item.price) * (item.quantity || 1), 0);
    if (commerceEvent('purchase', order.items || [], {
      transaction_id: order.id, value, shipping: Math.max(0, Number(order.total) - value),
    })) localStorage.setItem(key, '1');
  } catch { /* Analytics must never interrupt checkout. */ }
}
